import React,{useEffect} from "react";
import * as actions from "../../store/actions/index"
import {connect} from "react-redux";
import AddProduct from "../../containers/Admin/AddProducts/addProduct";
import Spinner from "../Spinner/Spinner";

const EditProductComponent = props=>{

    let productId = props.productId;

    useEffect( ()=>{

        if(productId){
             props.onFetchSingleProduct(null,productId).then(()=>{}).catch(error=>{alert(error)})
        }

    },[])

    if(!productId){
        return <h4>No ProductId</h4>
    }
    if(props.loading){
        return <Spinner/>
    }
    return(
        <>
            {
                props.singleProduct? <AddProduct  editProduct={props.singleProduct}/>
                :
                <h2>Product does not exist</h2>
            }
           
        </>
    )

}

const mapStateToProps = state=>{
    return {
        singleProduct:state.homeProducts.singleProduct,
        loading:state.homeProducts.loading,
    }
}

const mapDispatchToProps = dispatch=>{
    return {
        onFetchSingleProduct:(name,id)=>dispatch(actions.fetchSingleProduct(name,id)),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(EditProductComponent)